import { create } from "zustand";
import axios, { API_APP_URL } from "../_lib/Axios";
import * as yup from "yup";
import _ from "lodash";
import {
  MasterCountryProps,
  MasterNationalityProps,
  MasterChannelInformationProps,
} from "../_types/Master";

type MasterState = {
  isLoading: boolean;
  masterNationality: MasterNationalityProps[];
  masterChannelInformation: MasterChannelInformationProps[];
  setIsLoading: (isLoading: boolean) => void;
  setMasterNationality: (data: MasterNationalityProps[]) => void;
  setMasterChannelInformation: (data: MasterChannelInformationProps[]) => void;
  getMasterNationality: () => Promise<ResponseProps>;
  getMasterChannelInformation: () => Promise<ResponseProps>;
};

export const useMasterState = create<MasterState>((set: any, get: any) => ({
  isLoading: false,
  masterNationality: [],
  masterChannelInformation: [],
  setIsLoading: (isLoading) => {
    set({ isLoading: isLoading });
  },
  setMasterNationality: (data) => {
    set({ masterNationality: data });
  },
  setMasterChannelInformation: (data) => {
    set({ masterChannelInformation: data });
  },
  getMasterNationality: async () => {
    var resultForm: ResponseProps = {};
    const url = `${API_APP_URL}/api/MasterNationality?IsAll=true`;
    await axios
      .get(url)
      .then((res: ResponseProps) => {
        resultForm = res;
      })
      .catch((error: any) => {
        resultForm = error;
      });
    return resultForm;
  },
  getMasterChannelInformation: async () => {
    var resultForm: ResponseProps = {};
    const url = `${API_APP_URL}/api/MasterChannelInformation?IsAll=true&IsActive=true`;
    await axios
      .get(url)
      .then((res: ResponseProps) => {
        resultForm = res;
      })
      .catch((error: any) => {
        resultForm = error;
      });
    return resultForm;
  },
}));
